var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#374FC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0084 11.0973C22.9053 11.0135 22.7695 10.9815 22.6398 11.0104L11.3374 13.6187C11.1385 13.6644 10.9981 13.8423 11 14.0464V28.8265C11.0001 29.041 11.1566 29.2234 11.3686 29.256L22.6711 30.9949C22.9084 31.0314 23.1303 30.8686 23.1668 30.6313C23.1701 30.6095 23.1718 30.5875 23.1718 30.5654V11.4382C23.1723 11.3056 23.1121 11.1801 23.0084 11.0973Z",
    fill: "#374FC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1409 23.5189H15.0147L13.6089 18.498H14.6489L15.6101 22.2207L16.6573 18.498H17.5037L18.5581 22.2207L19.5192 18.498H20.5592L19.1534 23.5189H18.0273L17.0805 20.2051L16.1409 23.5189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4312 29.2611H22.737C22.4969 29.2611 22.3022 29.0665 22.3022 28.8264C22.3022 28.5863 22.4969 28.3917 22.737 28.3917H30.9965V13.6116H22.737C22.4969 13.6116 22.3022 13.417 22.3022 13.1769C22.3022 12.9368 22.4969 12.7422 22.737 12.7422H31.4311C31.6712 12.7422 31.8659 12.9368 31.8659 13.1769V28.8264C31.8659 29.0665 31.6713 29.2611 31.4312 29.2611Z",
    fill: "#374FC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6918 16.22H22.7365C22.4964 16.22 22.3018 16.0254 22.3018 15.7853C22.3018 15.5452 22.4964 15.3506 22.7365 15.3506H29.6918C29.9319 15.3506 30.1266 15.5452 30.1266 15.7853C30.1266 16.0254 29.9319 16.22 29.6918 16.22Z",
    fill: "#374FC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6914 18.8284H22.736C22.4959 18.8284 22.3013 18.6338 22.3013 18.3937C22.3013 18.1536 22.4959 17.959 22.736 17.959H29.6914C29.9314 17.959 30.1261 18.1536 30.1261 18.3937C30.1261 18.6338 29.9314 18.8284 29.6914 18.8284Z",
    fill: "#374FC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6914 21.4368H22.736C22.4959 21.4368 22.3013 21.2422 22.3013 21.0021C22.3013 20.762 22.4959 20.5674 22.736 20.5674H29.6914C29.9314 20.5674 30.1261 20.762 30.1261 21.0021C30.1261 21.2422 29.9314 21.4368 29.6914 21.4368Z",
    fill: "#374FC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6914 24.0452H22.736C22.4959 24.0452 22.3013 23.8506 22.3013 23.6105C22.3013 23.3704 22.4959 23.1758 22.736 23.1758H29.6914C29.9314 23.1758 30.1261 23.3704 30.1261 23.6105C30.1261 23.8506 29.9314 24.0452 29.6914 24.0452Z",
    fill: "#374FC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6914 26.6536H22.736C22.4959 26.6536 22.3013 26.459 22.3013 26.2189C22.3013 25.9788 22.4959 25.7842 22.736 25.7842H29.6914C29.9314 25.7842 30.1261 25.9788 30.1261 26.2189C30.1261 26.459 29.9314 26.6536 29.6914 26.6536Z",
    fill: "#374FC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.a2af920a317619c64d22c08946ec34e9.svg";
export { ForwardRef as ReactComponent };